export default __webpack_public_path__ + "static/media/ClanOT-Medium.4cc56b87.ttf";